type Refresh = () => Promise<unknown> | unknown;

type TransportRefresh = {
  kind: 'status';
  transports: Refresh;
  readiness: Refresh;
} | {
  kind: 'unlink';
  transports: Refresh;
  financials: Refresh;
  readiness: Refresh;
};

/**
 * Read models affected by transport commands on the customer-order screen.
 * Status changes affect physical delivery only; unlink also changes costs.
 * Call after a successful command/confirmation, preserving the caller's error
 * handling and permission-gated loaders. Do not turn a refetch into settlement.
 */
export async function refreshOrderTransportReadModels(refresh: TransportRefresh): Promise<void> {
  if (refresh.kind === 'unlink') {
    await Promise.all([refresh.transports(), refresh.financials(), refresh.readiness()]);
  } else {
    await Promise.all([refresh.transports(), refresh.readiness()]);
  }
}
